import {HealthReportLastNDaysPage} from './health-report-last-n-days';

function HealthReportLast30DaysPage(props: object) {
    return (
        <HealthReportLastNDaysPage {...props} nbDays={30} />
    );
}

export {HealthReportLast30DaysPage};
